import React from 'react'
import MultiFormWrapper from './MultiFormWrapper'
import DelegateFormInstance from './DelegateFormInstance'

export default class MultiFormGridItem extends React.Component{
	constructor(props) {
        super(props);
        this.state = {
            numberOfFormsToRender: this.props.numberOfFormsToRender,
        };
    }
     componentWillReceiveProps(nextProps) {

        this.setState({
            numberOfFormsToRender: nextProps.numberOfFormsToRender,

        });
    }


  onAddChild = () => {
        this.setState({
            numberOfFormsToRender: this.state.numberOfFormsToRender +1 ,
        });
    };

  render(){
   const children = [];

    for (var i = 0; i <= this.state.numberOfFormsToRender; i += 1) {
            //console.log('adding delegate to delegate instance form: ', this.props.alreadyExistingDelegates[i], this.state.numberOfFormsToRender);
            children.push(<DelegateFormInstance key={i} number={i} delegate={this.props.alreadyExistingDelegates[i]}
                                                isExistingDelegate={this.props.alreadyExistingDelegates[i] !== undefined} {...this.props}  />);


    }

  return (
   <div className="delegate-info-item">
   <MultiFormWrapper  key="multiFormWrapper"  children={children} numberOfFormsToRender={this.state.numberOfFormsToRender} propertyName={this.props.item.reference_number} onAddChild={this.onAddChild}></MultiFormWrapper>
   </div>
  )
  }
}


// WEBPACK FOOTER //
// ./src/components/MultiFormGridItem.js